import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/helpers/services/api.service';
import { HttpService } from 'src/app/helpers/services/http.service';
import { PublicService } from 'src/app/helpers/services/public.service';
import { DeleteComponent } from '../delete/delete.component';
import { InviteComponent } from '../invite/invite.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

@Component({
  selector: 'app-client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.css']
})
export class ClientProfileComponent {

  public clientId: number;
  client: any;
  msg: string;

  constructor(public activeModal: NgbActiveModal, public publicService: PublicService, public httpService: HttpService,
    private api: ApiService, private ngbModal: NgbModal) { }

  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
    this.httpService.list(this.api.clients.profile(this.clientId), {}, 'clientProfileLoader').subscribe({
      next: (res: any) => {
        if (res.success) {
          this.client = res.data;
        } else {
          this.msg = res.msg;
        }
      }
    });
  }

  resetPassword() {
    this.ngbModal.dismissAll();
    const modalRef = this.ngbModal.open(ResetPasswordComponent, { centered: true });
    modalRef.componentInstance.client = this.client;
  }

  invite() {
    const modalRef = this.ngbModal.open(InviteComponent, {});
    modalRef.componentInstance.client = this.client;
  }

  delete() {
    const modalRef = this.ngbModal.open(DeleteComponent, {});
    modalRef.componentInstance.id = this.client.id;
    modalRef.componentInstance.type = 'client';
    modalRef.componentInstance.message = `Do you want to delete ${this.client.dual_name} ?`;
    modalRef.result.then(() => this.ngbModal.dismissAll());
  }
}
